import { managementFeeConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  }
};

export const managementFees = (state = initalState, action) => {
  switch (action.type) {
    case managementFeeConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case managementFeeConstants.GET_ALL_SUCCESS:
      const { statistics, config, total, items, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          items,
          statistics,
          config
        }
      };
    case managementFeeConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case managementFeeConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
